export default __webpack_public_path__ + "static/media/therapy-card-img.72c87ade.jpg";